import { DOCUMENT } from '@angular/common';
import { Directive, ElementRef, Inject, Input, OnChanges, OnDestroy, OnInit, Renderer2 } from '@angular/core';
//import { IMediaTrack, IRemoteAudioTrack, IRemoteVideoTrack } from 'ngx-agora-sdk-ng';
import { render } from 'preact/compat';
import { Observable, Subscription } from 'rxjs';
import { BodySegmentationService } from 'src/app/core/services/body-segmentation.service';
// export interface IAgoraVideoPlayerTrackOption {
//   mediaTrack?: IMediaTrack;
//   audioTrack?: IRemoteAudioTrack;
//   videoTrack?: IRemoteVideoTrack;
// }

@Directive({
  selector: '[appAgoraVideoPlayer]'
})
export class AgoraVideoPlayerDirective implements OnInit, OnDestroy {

  vidOptions: any
  @Input('appAgoraVideoPlayer') set trackOption(options: any) {
    this.vidOptions = options;
    this.playTrack(this.vidOptions);
  }

  private poseDetectionSubscription: Subscription;
  @Input() poseDetection: Observable<void>;
  isPoseDetecting = false;

  constructor(private elementRef: ElementRef, private bodySegmentationService: BodySegmentationService, private renderer: Renderer2, @Inject(DOCUMENT) document: Document) { }

  ngOnInit(): void {
    this.poseDetectionSubscription = this.poseDetection.subscribe(() => {
      console.log('setup pose canvas')
      this.setupCanvas(this.vidOptions);
    });
  }

  private playTrack(tracks: any): void {

    while (this.elementRef.nativeElement.firstChild) {
      this.elementRef.nativeElement.removeChild(this.elementRef.nativeElement.firstChild);
    }
    if (tracks.mediaTrack) {
      tracks.mediaTrack.playVideo(this.elementRef.nativeElement, { fit: 'cover' });
      setTimeout(() => {
        tracks.mediaTrack.playVideo(this.elementRef.nativeElement, { fit: 'cover' });
      }, 2000)
      return;
    }
    if (tracks.audioTrack) {
      tracks.audioTrack.play();
    }

    if (tracks.videoTrack) {
      tracks.videoTrack.play(this.elementRef.nativeElement, { fit: 'cover' });
      setTimeout(() => {
        tracks.videoTrack.play(this.elementRef.nativeElement, { fit: 'cover' });
      }, 2000)

      // console.log(tracks.videoTrack.getMediaStreamTrack());
      //   this.setupCanvas(tracks);
    }


  }

  setupCanvas(ttracks: any) {
    const camera = !ttracks.mediaTrack ? ttracks.videoTrack : ttracks.mediaTrack['_cameraVideoTrack'];

    console.log(camera.getMediaStream())
    const stream = camera.getMediaStream();
    const videoTracks = stream.getVideoTracks();
    const tracks = stream.getTracks();
    tracks[0].oncapturehandlechange = this.captureChange;


    console.log('id ', videoTracks[0].id, ' ', tracks[0].id);
    // const videoContainerHtml = document.getElementById('agora-video-player-' + cameraId);
    // const videoHtml = document.getElementById('video_' + cameraId);
    // videoHtml.style['z-index'] = 1;
    // const canvasElement = this.renderer.createElement('canvas');
    // const scatterDiv = this.renderer.createElement('div');
    // scatterDiv.id = 'scatter-gl-container';
    // canvasElement.id = `video-canvas_${cameraId}`;
    // console.log('stats ', camera['_constraints'])
    // canvasElement.width = camera['_constraints'].width;
    // canvasElement.height = camera['_constraints'].height;
    // // this.renderer.setStyle(canvasElement, 'width', videoHtml.clientWidth+'px');
    // // this.renderer.setStyle(canvasElement, 'height', videoHtml.clientHeight+'px');
    // this.renderer.setStyle(canvasElement, 'position', 'absolute');
    // this.renderer.setStyle(canvasElement, 'top', 0);
    // this.renderer.setStyle(canvasElement, 'left', 0);
    // this.renderer.setStyle(canvasElement, 'z-index', 1000);
    // this.renderer.appendChild(videoContainerHtml, canvasElement);

    // //     scatterDiv.width= videoHtml.clientWidth;
    // //    this.renderer.setStyle(scatterDiv, 'width', videoHtml.clientWidth+'px');
    // //    scatterDiv.height = videoHtml.clientHeight;
    // //  this.renderer.setStyle(scatterDiv, 'height', videoHtml.clientHeight+'px');
    // // this.renderer.setStyle(scatterDiv, 'position', 'absolute');
    // // this.renderer.setStyle(scatterDiv, 'top', 0);
    // // this.renderer.setStyle(scatterDiv, 'left', 0);
    // // this.renderer.setStyle(scatterDiv, 'z-index', 1000);
    // // this.renderer.appendChild(videoContainerHtml, scatterDiv);

    // this.bodySegmentationService.startPoseDetection(camera, videoHtml, canvasElement);
  }
  captureChange(val: any) {
    console.log(val);
  }
  ngOnDestroy(): void {
    this.poseDetectionSubscription.unsubscribe();
  }
}
